import { render, staticRenderFns } from "./TaskList.vue?vue&type=template&id=07821f47&scoped=true"
import script from "./TaskList.vue?vue&type=script&lang=js"
export * from "./TaskList.vue?vue&type=script&lang=js"
import style0 from "./TaskList.vue?vue&type=style&index=0&id=07821f47&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07821f47",
  null
  
)

export default component.exports